import { gql } from "@outschool/ui-apollo";

export const markLearnerNotificationsRead = gql`
  mutation MarkLearnerNotificationsRead($uids: [ID!]!, $after: DateTime!) {
    markNotificationRead(uids: $uids, after: $after) {
      learnerHasUnreadNotifications
    }
  }
`;
